import React from "react"
import { Dropdown, DropdownButton } from "react-bootstrap"

import { cleanSmpSrcLabel, getTagKey } from "../../resources/utils"
import { id_accessor } from "../../../../components/shared_components_registration"

export default function AxesTagsColumn({ axisTagList, newTrendsList, updateAxis }) {
  return (
    <div className={"col-6"}>
      {axisTagList.length > 0 && (
        <>
          {axisTagList.map((tag, tag_idx) => {
            const tag_name = tag.label || tag.tag
            const is_new = newTrendsList.includes(getTagKey(tag))
            const css_color_class = is_new ? "notification-message" : ""
            return (
              <div key={`tag_${tag_idx}`} className={"row"} style={{ margin: "0" }}>
                <div className={"col-5 solid-grey-border"} style={{ padding: "5px" }}>
                  {is_new && <span className={css_color_class}>*</span>}
                  <span className={css_color_class}>{`${tag_name} (${tag.units})${
                    tag.smp_src ? ` [${cleanSmpSrcLabel(tag)}]` : ""
                  }:`}</span>
                </div>
                <div className={"col-7"} style={{ padding: "0" }}>
                  <DropdownButton
                    id={"axis-assignment"}
                    variant={"outline-primary"}
                    style={{ padding: "0" }}
                    title={tag.axis2 ? "Y2" : "Y1"}
                    disabled={!!tag[id_accessor]} // Separate logic handles axes assignment for "multi" plots - disabling for reduced user confusion
                  >
                    {["Y1", "Y2"].map((axis, i) => (
                      <Dropdown.Item
                        key={`Axis${i}`}
                        onClick={() =>
                          (tag.axis2 ? "Y2" : "Y1") !== axis && updateAxis({ ...tag, axis2: axis === "Y2" })
                        }
                      >
                        {axis}
                      </Dropdown.Item>
                    ))}
                  </DropdownButton>
                </div>
              </div>
            )
          })}
        </>
      )}
    </div>
  )
}
